import loader from 'little-loader';
import Promise from 'bluebird';

export class QuoraPixel {
    constructor(trackingId) {
        this.trackingId = trackingId;
    }

    getInstance() {
        if (!this.promise) {
            this.promise = new Promise((resolve, reject) => {
                if (!this.trackingId) {
                    return reject(new Error('Quora Pixel is disabled. No tracking id provided.'));
                }

                window.n = window.qp = (...args) => {
                    window.n.qp
                        ? window.n.qp(...args)
                        : window.n.queue.push(...args);
                };
                window.queue = [];

                loader('https://a.quora.com/qevents.js', (error) => {
                    if (error) {
                        return reject(error);
                    }

                    return resolve(window.qp);
                });
            }).then(this.initialize.bind(this));
        }

        return this.promise;
    }

    initialize(qp) {
        qp('init', this.trackingId);
        qp('track', 'ViewContent');

        return qp;
    }

    trackPageView() {
        return this.getInstance()
            .then((qp) => qp('track', 'PageView'))
            .catch(() => null);
    }

    trackSignUp() {
        return this.getInstance()
            .then((qp) => qp('track', 'SignUp'))
            .catch(() => null);
    }
}



// WEBPACK FOOTER //
// ./src/common/analytics/quora-pixel.js